<template>
  <div class="content">
    <!-- 应急物资  -->
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>应急物资</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style="display:flex;justify-content: space-between;align-items: center;height:60px;padding:0 1vw;" >
            <div class="grid-search">
              <!-- <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker> -->
              <el-input v-model="search.name" style="width:200px" placeholder="请输入人员姓名" clearable @change="doFilter">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div style="display:flex;margin:0px 0px 0px 0px;justify-content: space-between;align-items:center">
              <el-button type="primary" @click="addPlan">添加物资</el-button>
            </div>
          </div>
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :default-sort="{prop: 'clockTime', order: 'descending'}"
              :header-cell-style="{background:'#EBEBEB',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.count}}</span>
                </template>
              </el-table-column>
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span>{{ scope.row.place }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="使用记录" width="200">
                <template slot-scope="scope">
                  <el-button type="primary" plain size="mini" @click="updateFun(scope.row)" style="margin-top:0.5vh;margin-bottom:0.5vh;">编辑</el-button>
                  <el-button type="success" plain size="mini" @click="sumbitInfo(scope.row)" style="margin-top:0.5vh;margin-bottom:0.5vh;">查看</el-button>
                </template>
              </el-table-column>
              
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
            <!-- 人员修改 -->
            <el-dialog width="500px" title="添加物资" :visible.sync="modifyVisible" append-to-body>
              <el-form
                :model="workerInfo"
                ref="workerInfo"
                label-width="160px"
                label-position="right"
                :rules="rules"
              >
                <el-form-item label="名称：" prop="name">
                  <el-input v-model="workerInfo.name" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="数量：" prop="count">
                  <el-input v-model="workerInfo.count" type="number" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="位置：">
                  <el-input v-model="workerInfo.place" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                  <el-input v-model="workerInfo.remarks" type="textarea" :rows="2" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo('workerInfo')">确 定</el-button>
              </div>
            </el-dialog>

            <!-- 展示使用记录 -->
            <el-dialog width="1000px" title="物资使用记录" :visible.sync="hisVis" append-to-body>
              <el-table
                stripe
                :data="listHistory"
                
                style="width: 100%;"
                :header-cell-style="{background:'#EBEBEB',color:'#909399'}"
              >
                <template slot="empty">
                  <p>{{dataText1}}</p>
                </template>
                <el-table-column label="序号"  type="index" width="80"></el-table-column>
                <el-table-column label="名称">
                  <template slot-scope="scope">
                    <span>{{ scope.row.suppliesName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="数量">
                  <template slot-scope="scope">
                    <span>{{ scope.row.count}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注">
                  <template slot-scope="scope">
                    <span>{{ scope.row.remarks}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="使用人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="时间" width="240">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [
        // {index:'1',id:'1',name:'便携呼吸机',num:'2',around:'仓库',createDate:'2021-07-08'},
        // {index:'2',id:'2',name:'雨衣',num:'5',around:'仓库',createDate:'2021-07-08'},
        // {index:'3',id:'3',name:'绷带',num:'10',around:'仓库',createDate:'2021-07-08'},
        // {index:'4',id:'4',name:'止疼药',num:'10',around:'仓库',createDate:'2021-07-08'},
      ],
      search: {
        //查询
        name:'',
        // name: '',
        // projectId: '',
        // date:util.myTime.getCurTime(),
        // temperatureType:'2',
        // teamsId: '',
        // entId: '',
        // personName: '',
      },
      groupId: '',
      dataText: '数据加载中...',
      
      currentPage: 1,
      pageSize: 10,
      totalItems: 4,
      modifyVisible: false,
      workerInfo: {
        id: '',
        name:'',
        count:0,
        place:'',
        remarks:'',
        createBy:'',
        projectId:''
      },
      rules:{
        name:[
           { required: true, message: '请输入', trigger: 'blur' }
        ],
        count:[
           { required: true, message: '数量不能为空'}
        ]
      },
      //检查事项列表
      napeList:[],
      //责任单位
      entList:[],
      //责任人
      personList:[],
      //使用列表
      listHistory:[],
      dataText1:'数据加载中...',
      hisVis:false,
    }
  },
  created() {
    this.groupId = util.session.get('groupId')
  },
  mounted() {
    // this.search.projectId = this.groupId
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // this.getNapeList()
    // this.getEntList()
    // this.getPerosn()
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods: {
    //获取事项
    // getNapeList(){
    //   var that = this
    //   myHttp.selectProQsNapeListByProjectId({
    //     projectId:this.groupId
    //   }).then(function(resp){
    //     console.log(resp)
    //     if(resp.data.code=='200'){
    //       var list = resp.data.data.proQsNapes||[]
    //       that.napeList = list
    //     }
    //   })
    // },
    //责任单位
    // getEntList(){
    //   var that = this
    //   myHttp.getProjectEntByProjectId({
    //       projectId:this.groupId
    //   }).then(function(resp){
    //       if (resp.data.code == '200'){
    //           var list = resp.data.data.projectEnt || []
    //           that.entList = list
    //       }
    //   })
    // },
    //获取人员
    // getPerosn(){
    //   var that = this
    //   myHttp.getRoleUserList({
    //     userType:util.session.get('roleId'),
    //     groupId:this.groupId
    //   }).then(function(resp){
    //     if(resp.data.code=="200"){
    //         var list = resp.data.data.users||[];
    //         that.personList = list;
    //     }
    //   },function(){});
    // },
    //
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.selectProEmergencySuppliesPage(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for(var i=0;i<list.length;i++){
              list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
            }
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }else{
              that.totalItems = resp.data.data.pageInfo.total||0
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    
    //添加计划
    addPlan(){
      this.modifyVisible = true
      this.workerInfo.id = ''
      this.workerInfo.name = ''
      this.workerInfo.count = ''
      this.workerInfo.place = ''
      this.workerInfo.remarks = ''
      this.workerInfo.createBy = ''
      this.workerInfo.projectId = ''
    },
    //编辑
    updateFun(row){
      this.modifyVisible = true
      this.workerInfo.id = row.id
      this.workerInfo.name = row.name
      this.workerInfo.count = row.count
      this.workerInfo.place = row.place
      this.workerInfo.remarks = row.remarks
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    /**
     * 提交
     */
    modifyWorkerInfo(formName){
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.workerInfo.projectId = this.groupId
          that.workerInfo.createBy = util.session.get('user').id
          if(that.workerInfo.id == ''){
            myHttp.createProEmergencySupplies(that.workerInfo).then(function(resp){
              // console.log(resp)
              if(resp.data.code=='200'){
                that.$message.success('提交成功')
                that.modifyVisible = false
                that.getData()
              }else{
                that.$message.error(resp.data.msg)
              }
            })
          }else{
            that.workerInfo.updateBy = util.session.get('user').id
            myHttp.updateProEmergencySupplies(that.workerInfo).then(function(resp){
              if(resp.data.code=='200'){
                that.$message.success('提交成功')
                that.modifyVisible = false
                that.getData()
              }else{
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    /**
     * 查看
     */
    sumbitInfo(row){
      // this.$router.push({path:'/planProHis/'+row.id})
      this.hisVis = true
      var that = this
      myHttp.selectProEmergencyProcessingDetailsList({
        suppliesId:row.id,
        projectId:this.groupId
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.proEmergencyProcessingDetailss||[]
          that.listHistory = list
          if(list.length==0){
            that.dataText1 = '暂无数据'
          }
        }
      })
    },

  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }
  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }
  .content >>> .el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }
  .build-table {
    height: calc(100% - 100px);
    padding: 1vh;
    position: relative;
  }
  .cur{
    background: #ECF5FF !important;
    color:#409EFF !important  ;
  }
  div >>> .el-dialog__header {
    padding: 20px 20px 10px;
    text-align: center !important;
  }
  .send >>> .el-dialog__header {
    text-align: left !important;
  }
  div >>> .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: center;
    box-sizing: border-box;
  }
  div >>>.el-input-group--append .el-input__inner{
    width: 200px;
  }
  .dialog_send{
    margin:10px 0px 10px 35px;
  }
  .dialog_end{
    padding:30px 0px 10px 35px;
    display: flex;
    justify-content: flex-end;
  }
  .else{
    justify-content: space-between;
    border-top: 1px dotted #ECF5FF;
  }
  .tips{
        display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
  }
</style>